/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useOktaAuth } from '@okta/okta-react';
import { FDSHeader } from "@arctravel/react-fds";


function Header() {

    const { authState, oktaAuth } = useOktaAuth();
    const [userInfo, setUserInfo] = useState<any>(null);

  
    useEffect(() => {
      if (!authState || !authState.isAuthenticated) {
        setUserInfo(null);
      } else {
        oktaAuth.getUser().then((info: any) => {
          setUserInfo(info);
        });
      }
    }, [authState, oktaAuth]); 


    const signOut = async () => {
          oktaAuth.tokenManager.clear();
          await oktaAuth.authStateManager.updateAuthState();
          await oktaAuth.signOut({
             postLogoutRedirectUri: process.env.REACT_APP_OKTA_SIGNOUT_REDIRECT_URL
           });
      };
    
      if (!authState || authState?.isAuthenticated === false)
      {
        return <div></div>
      }
    

    return (      <FDSHeader
      config={{
        links: [
    
        ],
        secondaryLinks: [
          
            <a key={"signout"} className="navbar-utility-link" onClick={signOut} href="#">Sign Out</a>          
          
        ],
        notifications: [],
        productname: 'ARC Pay',
        username: userInfo?.email
      } as any}
     />)
}

export default Header